module.exports = __webpack_public_path__ + "img/d9ea06c159267a49e67f15b40de2d961.jpg";